import script from "./InspectBase.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectBase.vue?vue&type=script&setup=true&lang=js"

import "./InspectBase.vue?vue&type=style&index=0&id=cc4d3906&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc4d3906"]])

export default __exports__